import React, { useState, useEffect, useCallback } from 'react';
import api from '../services/api';

const eur = (n) => '€ ' + (parseFloat(n) || 0).toFixed(2).replace('.', ',');

const card = { background: '#fff', borderRadius: 10, border: '1px solid #e5e7eb', padding: 16, marginBottom: 12 };
const btn = { padding: '8px 14px', borderRadius: 8, border: '1px solid #d1d5db', background: '#fff', cursor: 'pointer', fontSize: 13 };
const btnPrimair = { ...btn, background: '#00D4AA', borderColor: '#00D4AA', color: '#0a0e1a', fontWeight: 600 };
const btnRood = { ...btn, borderColor: '#fca5a5', color: '#b91c1c' };
const inp = { padding: '6px 8px', borderRadius: 6, border: '1px solid #d1d5db', fontSize: 13 };

export default function Facturen() {
  const [tab, setTab] = useState('concept');
  const [facturen, setFacturen] = useState([]);
  const [open, setOpen] = useState(null);       // factuur-detail
  const [regels, setRegels] = useState([]);
  const [opmerking, setOpmerking] = useState('');
  const [btwPct, setBtwPct] = useState(21);
  const [bezig, setBezig] = useState(false);
  const [melding, setMelding] = useState(null);
  const [instOpdr, setInstOpdr] = useState([]);
  const [instPrijzen, setInstPrijzen] = useState([]);

  const laad = useCallback(async () => {
    try {
      if (tab === 'opdrachtgevers') {
        const r = await api.get('/facturatie/instellingen/opdrachtgevers');
        setInstOpdr(r.data.opdrachtgevers || []);
      } else if (tab === 'prijzen') {
        const r = await api.get('/facturatie/instellingen/prijzen');
        setInstPrijzen(r.data.materialen || []);
      } else {
        const r = await api.get('/facturatie?status=' + tab);
        setFacturen(r.data.facturen || []);
      }
    } catch (e) { console.error('Fout bij laden facturen:', e); }
  }, [tab]);

  const zetOpdr = async (id, veld, waarde) => {
    setInstOpdr(prev => prev.map(o => o.id === id ? { ...o, [veld]: waarde } : o));
  };
  const bewaarOpdr = async (o) => {
    try {
      await api.put('/facturatie/instellingen/opdrachtgever/' + o.id, {
        facturatie_actief: !!o.facturatie_actief,
        uurtarief: o.uurtarief,
        voorrijkosten: o.voorrijkosten,
      });
    } catch (e) { alert('Opslaan mislukt'); }
  };
  const bewaarPrijs = async (m) => {
    try { await api.put('/facturatie/instellingen/prijs/' + m.id, { verkoopprijs: m.verkoopprijs }); }
    catch (e) { alert('Prijs opslaan mislukt'); }
  };

  useEffect(() => { laad(); setOpen(null); }, [laad]);

  const openFactuur = async (id) => {
    try {
      const r = await api.get('/facturatie/' + id);
      setOpen(r.data.factuur);
      setRegels((r.data.regels || []).map(x => ({ ...x })));
      setOpmerking(r.data.factuur.opmerking || '');
      setBtwPct(parseFloat(r.data.factuur.btw_percentage) || 21);
      setMelding(null);
    } catch (e) { alert('Fout bij openen factuur'); }
  };

  const subtotaal = regels.reduce((s, r) => s + (parseFloat(r.aantal) || 0) * (parseFloat(r.prijs_per_stuk) || 0), 0);
  const btwBedrag = Math.round(subtotaal * (parseFloat(btwPct) || 0)) / 100;
  const totaal = subtotaal + btwBedrag;

  const zetRegel = (i, veld, waarde) => {
    setRegels(prev => prev.map((r, idx) => idx === i ? { ...r, [veld]: waarde } : r));
  };

  const opslaan = async () => {
    setBezig(true);
    try {
      await api.put('/facturatie/' + open.id, { opmerking, btw_percentage: btwPct, regels });
      setMelding('✅ Opgeslagen');
      await laad();
    } catch (e) { setMelding('❌ ' + ((e.response && e.response.data && e.response.data.message) || 'Opslaan mislukt')); }
    setBezig(false);
  };

  const bekijkPdf = async () => {
    try {
      const r = await api.get('/facturatie/' + open.id + '/pdf', { responseType: 'blob' });
      const url = URL.createObjectURL(new Blob([r.data], { type: 'application/pdf' }));
      window.open(url, '_blank');
    } catch (e) { alert('PDF openen mislukt'); }
  };

  const verstuur = async () => {
    if (!window.confirm('Factuur ' + open.factuurnummer + ' definitief versturen naar ' + (open.mail_naar || 'opdrachtgever') + '?')) return;
    setBezig(true);
    try {
      // eerst huidige wijzigingen opslaan, dan pas versturen
      await api.put('/facturatie/' + open.id, { opmerking, btw_percentage: btwPct, regels });
      const r = await api.post('/facturatie/' + open.id + '/verstuur');
      alert(r.data.message || 'Verzonden');
      setOpen(null);
      await laad();
    } catch (e) { alert((e.response && e.response.data && e.response.data.message) || 'Versturen mislukt'); }
    setBezig(false);
  };

  const verwijder = async () => {
    if (!window.confirm('Concept ' + open.factuurnummer + ' verwijderen?')) return;
    try {
      await api.delete('/facturatie/' + open.id);
      setOpen(null);
      await laad();
    } catch (e) { alert('Verwijderen mislukt'); }
  };

  return (
    <div style={{ padding: 24, maxWidth: 1100, margin: '0 auto' }}>
      <h1 style={{ fontSize: 22, marginBottom: 4 }}>💰 Facturen</h1>
      <p style={{ color: '#6b7280', marginTop: 0, fontSize: 13 }}>
        Concepten ontstaan automatisch bij afgeronde werkorders van opdrachtgevers met facturatie aan. Controleer, pas aan en verstuur.
      </p>

      <div style={{ display: 'flex', gap: 8, margin: '14px 0' }}>
        {[['concept', '📝 Concepten'], ['verzonden', '📤 Verzonden'], ['opdrachtgevers', '🏢 Opdrachtgevers'], ['prijzen', '🏷️ Prijzen']].map(([t, l]) => (
          <button key={t} onClick={() => setTab(t)}
            style={{ ...btn, ...(tab === t ? { background: '#0a0e1a', color: '#fff', borderColor: '#0a0e1a' } : {}) }}>
            {l}
          </button>
        ))}
      </div>

      {tab === 'opdrachtgevers' && (
        <div style={card}>
          <p style={{ color: '#6b7280', fontSize: 13, marginTop: 0 }}>
            Vink aan welke opdrachtgevers gefactureerd worden. Concepten ontstaan dan automatisch bij afgeronde werkorders.
          </p>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
            <thead><tr style={{ textAlign: 'left', color: '#6b7280' }}>
              <th style={{ padding: 6 }}>Opdrachtgever</th><th>Factuur-e-mail</th>
              <th style={{ width: 90 }}>Facturatie</th><th style={{ width: 120 }}>Uurtarief</th><th style={{ width: 120 }}>Voorrijkosten</th>
            </tr></thead>
            <tbody>
              {instOpdr.map(o => (
                <tr key={o.id} style={{ borderTop: '1px solid #f1f5f9' }}>
                  <td style={{ padding: 6, fontWeight: 600 }}>{o.naam}</td>
                  <td style={{ color: o.mail_naar ? '#6b7280' : '#b91c1c' }}>{o.mail_naar || 'ontbreekt!'}</td>
                  <td><input type="checkbox" checked={!!o.facturatie_actief}
                    onChange={e => { zetOpdr(o.id, 'facturatie_actief', e.target.checked); bewaarOpdr({ ...o, facturatie_actief: e.target.checked }); }} /></td>
                  <td><input type="number" step="0.50" placeholder="€/uur" style={{ ...inp, width: 90 }}
                    value={o.uurtarief == null ? '' : o.uurtarief}
                    onChange={e => zetOpdr(o.id, 'uurtarief', e.target.value)}
                    onBlur={() => bewaarOpdr(o)} /></td>
                  <td><input type="number" step="0.50" placeholder="€" style={{ ...inp, width: 90 }}
                    value={o.voorrijkosten == null ? '' : o.voorrijkosten}
                    onChange={e => zetOpdr(o.id, 'voorrijkosten', e.target.value)}
                    onBlur={() => bewaarOpdr(o)} /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {tab === 'prijzen' && (
        <div style={card}>
          <p style={{ color: '#6b7280', fontSize: 13, marginTop: 0 }}>
            Verkoopprijs per materiaal (excl. BTW). Zonder prijs komt het materiaal op € 0,00 op het concept — daar pas je 'm dan handmatig aan.
          </p>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
            <thead><tr style={{ textAlign: 'left', color: '#6b7280' }}>
              <th style={{ padding: 6 }}>Materiaal</th><th style={{ width: 90 }}>Code</th>
              <th style={{ width: 80 }}>Eenheid</th><th style={{ width: 130 }}>Verkoopprijs</th>
            </tr></thead>
            <tbody>
              {instPrijzen.map(m => (
                <tr key={m.id} style={{ borderTop: '1px solid #f1f5f9' }}>
                  <td style={{ padding: 6 }}>{m.naam}</td>
                  <td style={{ color: '#94a3b8' }}>{m.code || '—'}</td>
                  <td>{m.eenheid}</td>
                  <td><input type="number" step="0.01" placeholder="€" style={{ ...inp, width: 100 }}
                    value={m.verkoopprijs == null ? '' : m.verkoopprijs}
                    onChange={e => setInstPrijzen(prev => prev.map(x => x.id === m.id ? { ...x, verkoopprijs: e.target.value } : x))}
                    onBlur={() => bewaarPrijs({ ...m, verkoopprijs: (instPrijzen.find(x => x.id === m.id) || m).verkoopprijs })} /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {!open && (tab === 'concept' || tab === 'verzonden') && (
        <div style={card}>
          {facturen.length === 0 && <p style={{ color: '#6b7280', margin: 8 }}>Geen facturen in deze status.</p>}
          {facturen.map(f => (
            <div key={f.id} onClick={() => openFactuur(f.id)}
              style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 8px', borderBottom: '1px solid #f1f5f9', cursor: 'pointer' }}>
              <div>
                <strong>{f.factuurnummer}</strong>
                <span style={{ color: '#6b7280' }}> · {f.opdrachtgever_naam}</span>
                {f.ordernummer ? <span style={{ color: '#94a3b8', fontSize: 12 }}> · {f.ordernummer} {f.werkorder_titel}</span> : null}
              </div>
              <div style={{ display: 'flex', gap: 16, alignItems: 'center' }}>
                <span style={{ fontWeight: 700 }}>{eur(f.totaal)}</span>
                <span style={{ color: '#94a3b8', fontSize: 12 }}>
                  {new Date(f.verzonden_op || f.created_at).toLocaleDateString('nl-NL')}
                </span>
              </div>
            </div>
          ))}
        </div>
      )}

      {open && (
        <div style={card}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
            <div>
              <button style={btn} onClick={() => { setOpen(null); laad(); }}>← Terug</button>
              <strong style={{ marginLeft: 12, fontSize: 16 }}>{open.factuurnummer}</strong>
              <span style={{ color: '#6b7280' }}> · {open.opdrachtgever_naam}</span>
              {open.mail_naar ? <span style={{ color: '#94a3b8', fontSize: 12 }}> · {open.mail_naar}</span>
                : <span style={{ color: '#b91c1c', fontSize: 12 }}> · geen factuur-e-mail!</span>}
            </div>
            <div style={{ display: 'flex', gap: 8 }}>
              <button style={btn} onClick={bekijkPdf}>📄 PDF</button>
              {open.status === 'concept' && <>
                <button style={btnRood} onClick={verwijder}>Verwijderen</button>
                <button style={btn} disabled={bezig} onClick={opslaan}>Opslaan</button>
                <button style={btnPrimair} disabled={bezig} onClick={verstuur}>📤 Versturen</button>
              </>}
            </div>
          </div>
          {melding && <p style={{ fontSize: 13 }}>{melding}</p>}

          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
            <thead>
              <tr style={{ textAlign: 'left', color: '#6b7280' }}>
                <th style={{ padding: 6 }}>Omschrijving</th>
                <th style={{ width: 90 }}>Aantal</th>
                <th style={{ width: 80 }}>Eenheid</th>
                <th style={{ width: 100 }}>Prijs</th>
                <th style={{ width: 100, textAlign: 'right' }}>Totaal</th>
                {open.status === 'concept' && <th style={{ width: 34 }} />}
              </tr>
            </thead>
            <tbody>
              {regels.map((r, i) => (
                <tr key={i} style={{ borderTop: '1px solid #f1f5f9' }}>
                  <td style={{ padding: 6 }}>
                    {open.status === 'concept'
                      ? <input style={{ ...inp, width: '95%' }} value={r.omschrijving} onChange={e => zetRegel(i, 'omschrijving', e.target.value)} />
                      : r.omschrijving}
                  </td>
                  <td>{open.status === 'concept'
                    ? <input type="number" step="0.25" style={{ ...inp, width: 70 }} value={r.aantal} onChange={e => zetRegel(i, 'aantal', e.target.value)} />
                    : r.aantal}</td>
                  <td>{r.eenheid}</td>
                  <td>{open.status === 'concept'
                    ? <input type="number" step="0.01" style={{ ...inp, width: 80 }} value={r.prijs_per_stuk} onChange={e => zetRegel(i, 'prijs_per_stuk', e.target.value)} />
                    : eur(r.prijs_per_stuk)}</td>
                  <td style={{ textAlign: 'right', fontWeight: 600 }}>
                    {eur((parseFloat(r.aantal) || 0) * (parseFloat(r.prijs_per_stuk) || 0))}
                  </td>
                  {open.status === 'concept' && (
                    <td><button style={{ ...btn, padding: '2px 8px', color: '#b91c1c' }}
                      onClick={() => setRegels(prev => prev.filter((_, idx) => idx !== i))}>×</button></td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>

          {open.status === 'concept' && (
            <button style={{ ...btn, marginTop: 8 }}
              onClick={() => setRegels(prev => [...prev, { soort: 'overig', omschrijving: '', aantal: 1, eenheid: 'stuk', prijs_per_stuk: 0 }])}>
              + Regel toevoegen
            </button>
          )}

          <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 14 }}>
            <div style={{ minWidth: 260 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 0' }}>
                <span>Subtotaal</span><strong>{eur(subtotaal)}</strong>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 0', alignItems: 'center' }}>
                <span>BTW{' '}
                  {open.status === 'concept'
                    ? <input type="number" step="0.5" style={{ ...inp, width: 60 }} value={btwPct} onChange={e => setBtwPct(e.target.value)} />
                    : btwPct}%</span>
                <strong>{eur(btwBedrag)}</strong>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderTop: '2px solid #0a0e1a', fontSize: 16 }}>
                <strong>Totaal</strong><strong style={{ color: '#059669' }}>{eur(totaal)}</strong>
              </div>
            </div>
          </div>

          <div style={{ marginTop: 10 }}>
            <label style={{ fontSize: 12, color: '#6b7280' }}>Opmerking op factuur (optioneel)</label>
            {open.status === 'concept'
              ? <textarea style={{ ...inp, width: '100%', minHeight: 50, marginTop: 4 }} value={opmerking} onChange={e => setOpmerking(e.target.value)} />
              : <p style={{ fontSize: 13 }}>{opmerking || '—'}</p>}
          </div>
        </div>
      )}
    </div>
  );
}
